import React, { Component } from "react";
import "./maincontent.css";
import Nav from "./Nav.js";
import Footer from "./Footer.js";

export default class MainContent extends React.Component {
  render() {
    return (
      <div>
        <Nav />
        <div class="wrapper">
          {/* <img src="./images/iphone_blur.png" class="blurred-iphone-left" /> */}
          <div class="text">
            <h1>Host drops from your phone.</h1>
            <div class="header-buttons">
              {/* <div class="host-a-drop"><p>Host a drop</p></div> */}
              <a
                href="https://apps.apple.com/us/app/firstfloor-live-nft-drops/id1596874081"
                target="_blank"
              >
                <div class="get-the-app">
                  <p>Get the app</p>
                </div>
              </a>
            </div>
          </div>

          <div class="animation-phone">
            <div class="main-content floating">
              <img src="./images/fire_1.png" class="fire1 floating1"></img>
              <img src="./images/fire_2.png" class="fire2 floating2"></img>
              <img src="./images/fire_3.png" class="fire3 floating3"></img>
              <img src="./images/fire_4.png" class="fire4 floating4"></img>

              <img src="./images/burning.png" class="corner-burning"></img>

              <img src="./images/iphone_12.png" class="iphone_middle_resized" />
              <img
                src="./images/image_mock.png"
                class="middle_screen screen_background_blur"
              />
              <video autoPlay loop playsInline muted class="middle_screen">
                <source src="./images/lobby.mp4" type="video/mp4"></source>
              </video>
              {/* <img src="./images/image_mock.png" class="middle_screen"/> */}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
